import { TerceraChartRendererDrawingAdvancedParamsEnum } from './ChartConstants';
export class TerceraChartAdvancedParams {
    constructor() {
        this.DrawPointers = [];
    }
}
